// src/pages/ProfilePage.jsx
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";

// --- СТИЛИ (как у вас в примере) ---
const Container = styled.div`
    padding: 20px;
    background: #f8f9fa;
    min-height: 100vh;
`;

const Header = styled.h1`
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin-bottom: 32px;
`;

const StatusBadge = styled.span`
  &.working   { background: #fff3cd; color: #856404; }
  &.completed { background: #d4edda; color: #155724; }
  &.cancelled { background: #f8d7da; color: #721c24; }
  &.waiting_confirmation { background: #e7f3ff; color: #0066cc; }
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  text-transform: uppercase;
`;

const MainGrid = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 20px;
    margin-bottom: 32px;

    @media (max-width: 1200px) {
        grid-template-columns: 1fr 1fr 1fr;
    }
    @media (max-width: 800px) {
        grid-template-columns: 1fr;
    }
`;

const Card = styled.div`
    background: white;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    border: 1px solid #e8ecef;
`;

const CardTitle = styled.h3`
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 0.5px;
    font-weight: 600;
    color: #333;
    margin-bottom: 20px;
`;

const UserAvatar = styled.div`
    width: 48px; height: 48px;
    border-radius: 50%;
    background: linear-gradient(135deg,#667eea 0%,#764ba2 100%);
    display:flex; align-items:center; justify-content:center;
    color:white; font-weight:600; font-size:18px;
    margin-bottom:16px;
`;

const UserName = styled.h2`
    font-size:18px; font-weight:600; color:#333;
    margin-bottom:4px;
`;

const UserRole = styled.p`
    font-size:13px; color:#666; margin-bottom:16px;
`;

const UserInfo = styled.div`
    & > div { margin-bottom:8px; font-size:13px; color:#555; }
`;

const ActionButton = styled.button`
    background: #4285f4;
    color: #fff;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 10px;
    transition: background 0.2s;

    &:hover {
        background: #3367d6;
    }

    a {
        color: inherit;
        text-decoration: none;
        display: inline-block;
        width: 100%;
        height: 100%;
        line-height: 1;
    }
`;

const AddressCard = styled(Card)`
    & .address-text {
        font-size:13px; line-height:1.6; color:#555;
        white-space: pre-line; margin-bottom:16px;
    }
`;

const StatsGrid = styled.div`
    display:grid; grid-template-rows:repeat(3,1fr); gap:12px;
`;

const StatCard = styled.div`
    background:white; border-radius:12px; padding:16px;
    display:flex; align-items:center;
    box-shadow:0 2px 8px rgba(0,0,0,0.06);
    border:1px solid #e8ecef;
`;

const StatIcon = styled.div`
    width:40px; height:40px; border-radius:8px;
    display:flex; align-items:center; justify-content:center;
    margin-right:12px; background:${p=>p.bg}; color:white;
    font-size:18px;
`;

const StatContent = styled.div`
    & .number { font-size:20px; font-weight:700; color:#333; }
    & .label  { font-size:11px; color:#666; text-transform:uppercase; letter-spacing:0.5px; margin-top:2px; }
`;

const OrdersSection = styled.div`
    background:white; border-radius:12px; padding:24px;
    box-shadow:0 2px 8px rgba(0,0,0,0.06); border:1px solid #e8ecef;

    @media (max-width: 480px) {
        padding: 16px;
    }
`;

const SectionHeader = styled.div`
    display:flex; justify-content:space-between; align-items:center;
    margin-bottom:20px;
`;

const SectionTitle = styled.h3`
    text-transform:uppercase; font-size:12px; letter-spacing:0.5px;
    font-weight:600; color:#333; margin:0;
`;

const ShowAllLink = styled.a`
    color:#4285f4; text-decoration:none; font-size:13px; font-weight:500;
    cursor:pointer; &:hover{text-decoration:underline;}
`;

// Обычная таблица для десктопа
const OrdersTable = styled.table`
  width:100%; border-collapse:collapse;
  
  th { padding:12px 8px; font-size:11px; font-weight:600;
       color:#666; text-transform:uppercase; letter-spacing:0.5px;
       border-bottom:1px solid #e8ecef; text-align:left; }
  td { padding:16px 8px; font-size:13px; color:#333; border-bottom:1px solid #f5f5f5; }
  .status { font-weight:600; padding:4px 8px; border-radius:4px; font-size:11px; text-transform:uppercase; }
  .working   { background:#fff3cd; color:#856404; }
  .completed { background:#d4edda; color:#155724; }
  .cancelled { background:#f8d7da; color:#721c24; }
  .waiting_confirmation { background:#e7f3ff; color:#0066cc; }

  @media (max-width: 768px) {
    display: none;
  }
`;

// Мобильный вариант заказов - карточки
const MobileOrdersList = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const MobileOrderCard = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  border: 1px solid #e8ecef;
`;

const MobileOrderHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

const MobileOrderId = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #333;
`;

const MobileOrderInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 12px;
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const MobileOrderField = styled.div`
  font-size: 12px;
  
  .label {
    color: #666;
    font-weight: 500;
    display: block;
    margin-bottom: 2px;
  }
  
  .value {
    color: #333;
    font-weight: 400;
  }
`;

const MobileOrderAction = styled.div`
  text-align: right;
  
  a {
    color: #4285f4;
    text-decoration: none;
    font-size: 12px;
    font-weight: 500;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

const ViewDetailsButton = styled.button`
  background:none; border:none; color:#4285f4; font-size:13px;
  cursor:pointer; &:hover{text-decoration:underline;}
`;

// -------------------------------------------------------------------

export default function ProfilePage() {
    const navigate = useNavigate();
    const [userInfo, setUserInfo]     = useState(null);
    const [orders, setOrders]         = useState([]);
    const [stats, setStats]           = useState({ total:0, pending:0, completed:0 });
    const token = sessionStorage.getItem("accessToken");

    useEffect(() => {
        if (!token) return navigate("/");

        axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/user/user-info`,
            { headers:{ Authorization:`Bearer ${token}` } }
        )
            .then(({ data }) => setUserInfo(data))
            .catch(()=>navigate("/"));

        axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/user/user-orders`,
            { headers:{ Authorization:`Bearer ${token}` } }
        )
            .then(({ data }) => {
                setOrders(data);
                const total     = data.length;
                const pending   = data.filter(o=>o.payStatus==="PENDING").length;
                const completed = data.filter(o=>o.payStatus==="COMPLETED").length;
                setStats({ total, pending, completed });
            })
            .catch(console.error);
    }, [navigate, token]);

    if (!userInfo) return <Container>Загрузка профиля…</Container>;

    const getInitials = () =>
        `${userInfo.firstName?.[0]||""}${userInfo.lastName?.[0]||""}`;

    const getStatusClass = s => {
        if (/РАБОТЕ/i.test(s)) return "working";
        if (/ЗАВЕРШ/i.test(s)) return "completed";
        if (/ОТМ/i.test(s)) return "cancelled";
        if (/WAITING_CONFIRMATION/i.test(s)) return "waiting_confirmation";
        return "";
    };

    const getStatusText = s => {
        if (s === "WAITING_CONFIRMATION") return "ОЖИДАНИЕ";
        return s;
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleString("ru", {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <Container>
            <Header>Привет, {userInfo.firstName}</Header>

            <MainGrid>
                {/* Account Info */}
                <Card>
                    <CardTitle>Информация об аккаунте</CardTitle>
                    <UserAvatar>{getInitials()}</UserAvatar>
                    <UserName>{userInfo.firstName} {userInfo.lastName}</UserName>
                    <br/>
                    {/*<UserRole>{userInfo.role}</UserRole>*/}
                    <UserInfo>
                        <div>Имя пользователя: {userInfo.username}</div>
                        <div>Телефон: {userInfo.phoneNumber}</div>
                        {/*<div>Тип пользователя: {userInfo.userType}</div>*/}
                    </UserInfo>
                    <ActionButton>
                        <Link to="/profile/settings">Изменить аккаунт</Link>
                    </ActionButton>
                </Card>

                {/*
                  <AddressCard>
                    <CardTitle>Адрес для выставления счета</CardTitle>
                    <div className="address-text">
                        {userInfo.companyName}<br/>
                        BIN: {userInfo.bin}
                    </div>
                    <ActionButton>Редактировать адрес</ActionButton>
                </AddressCard>
                 */}

                {/* Stats */}
                <StatsGrid>
                    <StatCard>
                        <StatIcon bg="linear-gradient(135deg,#667eea 0%,#764ba2 100%)">📋</StatIcon>
                        <StatContent>
                            <div className="number">{stats.total}</div>
                            <div className="label">Полный заказ</div>
                        </StatContent>
                    </StatCard>
                    <StatCard>
                        <StatIcon bg="linear-gradient(135deg,#f093fb 0%,#f5576c 100%)">⏳</StatIcon>
                        <StatContent>
                            <div className="number">{stats.pending}</div>
                            <div className="label">Отложенные</div>
                        </StatContent>
                    </StatCard>
                    <StatCard>
                        <StatIcon bg="linear-gradient(135deg,#4facfe 0%,#00f2fe 100%)">✅</StatIcon>
                        <StatContent>
                            <div className="number">{stats.completed}</div>
                            <div className="label">Завершенные</div>
                        </StatContent>
                    </StatCard>
                </StatsGrid>
            </MainGrid>

            {/* Orders */}
            <OrdersSection>
                <SectionHeader>
                    <SectionTitle>Последний заказ</SectionTitle>
                    <Link to="/profile/orders">
                        Показать все →
                    </Link>
                </SectionHeader>

                {/* Десктопная таблица */}
                <OrdersTable>
                    <thead>
                    <tr>
                        <th>Номер артикула</th>
                        <th>Состояние</th>
                        <th>Дата</th>
                        <th>Всего</th>
                        <th>Действие</th>
                    </tr>
                    </thead>
                    <tbody>
                    {orders.slice(-7).reverse().map(o => (
                        <tr key={o.orderId}>
                            <td>#{o.orderId}</td>
                            <td>
                                <StatusBadge className={getStatusClass(o.payStatus)}>
                                    {getStatusText(o.payStatus)}
                                </StatusBadge>
                            </td>
                            <td>{formatDate(o.orderDate)}</td>
                            <td>{o.totalPrice}</td>
                            <td>
                                <Link to={`/profile/orders/${o.orderId}`} style={{ color: "#4285f4", textDecoration: "none" }}>
                                    Посмотреть подробности →
                                </Link>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </OrdersTable>

                {/* Мобильные карточки */}
                <MobileOrdersList>
                    {orders.slice(-7).reverse().map(o => (
                        <MobileOrderCard key={o.orderId}>
                            <MobileOrderHeader>
                                <MobileOrderId>#{o.orderId}</MobileOrderId>
                                <StatusBadge className={getStatusClass(o.payStatus)}>
                                    {getStatusText(o.payStatus)}
                                </StatusBadge>
                            </MobileOrderHeader>

                            <MobileOrderInfo>
                                <MobileOrderField>
                                    <span className="label">ДАТА</span>
                                    <span className="value">{formatDate(o.orderDate)}</span>
                                </MobileOrderField>
                                <MobileOrderField>
                                    <span className="label">ВСЕГО</span>
                                    <span className="value">{o.totalPrice}</span>
                                </MobileOrderField>
                            </MobileOrderInfo>

                            <MobileOrderAction>
                                <Link to={`/profile/orders/${o.orderId}`}>
                                    Посмотреть подробности →
                                </Link>
                            </MobileOrderAction>
                        </MobileOrderCard>
                    ))}
                </MobileOrdersList>
            </OrdersSection>
        </Container>
    );
}
